import React, { useState, useEffect } from "react";
import { Modal } from "antd";

const LocationModal = ({ isOpen, onCancel, location }) => {
  const [mapKey, setMapKey] = useState(0);

  const handleCancel = () => {
    setMapKey((prev) => prev + 1);
    onCancel();
  };

  useEffect(() => {
    if (isOpen) {
      setMapKey((prev) => prev + 1);
    }
  }, [isOpen, location]);

  const { lat, lng } = location || {};

  const mapUrl =
    lat && lng
      ? `https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`
      : null;

  return (
    <Modal
      title="Location"
      closable
      open={isOpen}
      onCancel={handleCancel}
      width={600}
      footer={null}
      destroyOnClose={true}
      style={{ top: 100 }}
      afterClose={() => {
        setMapKey((prev) => prev + 1);
      }}
    >
      <div className="row px-1">
        <div className="w-100">
          {mapUrl ? (
            <iframe
              key={mapKey}
              src={mapUrl}
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Map"
            ></iframe>
          ) : (
            <div className="text-center py-5 text-muted">No location found</div>
          )}
        </div>

        <div className="text-right mt-3">
          <button
            onClick={handleCancel}
            className="btn btn_outlined fs_12 btn-sm text-dark px-3 py-1 mr-2"
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default LocationModal;
